
export const ERROR_CODE = {
  NEGATIVE_BALANCE: '0100-0039',
  MULTIPLE_SUBSCRIPTION: '1100-0037',
  MULTIPLE_BINDING: '0100-0016',
  MULTIPLE_BINDING_WITH_FAD: '0100-0077',
  PLAY_EMAIL_IN_USE: '0100-0050',
  OUT_OF_STOCK: '00007',
  QUARANTINE: '0100-0053',
  CHANGE_IN_PROGRESS: '2100-0015',
  // Pending package / market-offer change (Metranet order codes)
  CHANGE_IN_PROGRESS_PACKAGE: '1100-0021',
  CHANGE_IN_PROGRESS_MARKET_OFFER: '1100-0019',
  KEEP_SUB_PENDING_CHANGE: '0033',
  BINDING: '2100-0007',
  SUB_USER_1: 'COMMERCE.0004',
  SUB_USER_2: 'COMMERCE.0005',
  CVR_NO_MATCH: '00008',
  CHANGE_SUB_NEGATIVE_BALANCE_1: '2100-0009',
  CHANGE_SUB_NEGATIVE_BALANCE_2: '2100-0010',
  NUMBER_IN_USE: '1000-0002'
}

export const WARNING_CODE = {
  CHANGE_END_OF_MONTH: ['0100-0054', '0100-0056'],
  CHANGE_END_OF_DAY: '0100-0055'
}
export const SIGN_UP_ERROR_TYPES = {
  NEGATIVE_BALANCE: 'negativeBalance',
  MULTIPLE_SUBSCRIPTION: 'multipleSubscriptions'
}
